var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-container-page"},[_c('div',{staticClass:"header"},[_vm._m(0)],1),_c('div',{staticClass:"main-page"},[(_vm.isRouterAlive)?_c('router-view'):_vm._e()],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header-bar')
}]

export { render, staticRenderFns }